export default __webpack_public_path__ + "static/media/lampstyle-light-gray.6dcc859f.svg";